import { render, staticRenderFns } from "./MultiInsuredHelpList.vue?vue&type=template&id=40e828c8&"
import script from "./MultiInsuredHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiInsuredHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports